import React from 'react'
import * as S from './styles'

export type StatusTagProps = {
  variant?: 'orange' | 'purple' | 'green' | 'gray'
  children?: string
}

export const StatusTag = ({ variant, children }: StatusTagProps) => {
  return (
    <S.StatusTag variant={variant}>
      <span>{children}</span>
    </S.StatusTag>
  )
}
